const map: Record<string, string> = {
  ACTIVE: 'badge-success',
  PAUSED: 'badge-warning',
  DISCONNECTED: 'badge-error',
  OPERATOR: 'badge-info',
  USER: 'badge-ghost',
  ok: 'badge-success',
  stale: 'badge-warning',
  error: 'badge-error',
  unknown: 'badge-ghost',
  DRAFT: 'badge-warning',
  QUEUED: 'badge-info',
  SENT: 'badge-info',
  REPLIED: 'badge-success',
  INTERVIEW: 'badge-accent',
  REJECTED: 'badge-error',
};

export default function StatusBadge({ value }: { value: string }) {
  return <span className={`badge badge-sm ${map[value] ?? 'badge-ghost'}`}>{value}</span>;
}
